import { computed } from 'vue';

export type FormatKind = 'text'|'currency'|'decimal'|'percentage'|'date';

export function getByPath(obj: any, path?: string) {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((acc: any, k: string) => (acc ? acc[k] : undefined), obj);
}

export function prettyLabel(s?: string) {
  return (s || '')
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\b\w/g, c => c.toUpperCase());
}

export function formatValue(val: any, format?: FormatKind, currency = 'MXN') {
  if (val == null || val === '') return '—';
  switch (format) {
    case 'currency':
      return new Intl.NumberFormat('es-MX', { style:'currency', currency, minimumFractionDigits: 2 }).format(Number(val));
    case 'decimal':     return Number(val).toLocaleString('es-MX');
    case 'percentage':  return `${Number(val).toLocaleString('es-MX')}%`;
    case 'date': {
      const d = new Date(val);
      return isNaN(d.getTime()) ? String(val) : d.toLocaleString('es-MX');
    }
    default: return String(val);
  }
}
